import React, { createContext, useContext, useState, useEffect } from 'react';
import { authTelegram, getMe } from '../api/client';

interface User {
  id: number;
  telegram_id: number;
  username: string | null;
  first_name: string | null;
  last_name: string | null;
  trial_used: boolean;
  trial_expires_at: string | null;
  active_subscription: any | null;
  searches_count: number;
  active_searches_count: number;
  is_admin: boolean;
  listings_found_today: number;
}

interface AuthContextType {
  user: User | null;
  loading: boolean;
  isAuthenticated: boolean;
  login: (initData: string) => Promise<void>;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('navigator_token');
    if (token) {
      getMe()
        .then((data) => setUser(data))
        .catch(() => localStorage.removeItem('navigator_token'))
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (initData: string) => {
    const response = await authTelegram(initData);
    localStorage.setItem('navigator_token', response.access_token);
    sessionStorage.removeItem('navigator_reload_guard');
    setUser(response.user);
  };

  const logout = () => {
    localStorage.removeItem('navigator_token');
    setUser(null);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        loading,
        isAuthenticated: !!user,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
};
